(function () {
    'use strict';

    var config = window.MeilisearchProductGridConfig;
    if (!config) {
        console.error('[ms-pg] MeilisearchProductGridConfig not found.');
        return;
    }

    var MEILISEARCH_HOST = config.meilisearchHost;
    var MEILISEARCH_API_KEY = config.meilisearchApiKey;
    var MEILISEARCH_INDEX = config.meilisearchIndex;
    var collectionId = config.collectionId || null;
    var collectionHandle = config.collectionHandle || null;
    var currentLocale = config.currentLocale || 'de';
    var showOutOfStock = config.showOutOfStock !== false;
    var productsPerPage = (window.matchMedia('(max-width: 768px)').matches
        ? config.productsPerPageMobile
        : config.productsPerPageDesktop) || config.productsPerPage || 24;
    var searchMode = config.searchMode === true;
    var initialQuery = new URLSearchParams(window.location.search).get('q') || config.initialQuery || '';
    var variantSwatches = (config.variantSwatches && typeof config.variantSwatches === 'object') ? config.variantSwatches : {};
    var T_CART_ADD = config.cartAdd || 'Hinzufügen';
    var T_CART_ADDING = config.cartAdding || 'Hinzufügen...';
    var T_CART_ADDED = config.cartAdded || 'Hinzugefügt';
    var T_CART_LIMIT = config.cartLimitReached || 'Limit erreicht';
    var T_SOLD_OUT = config.productSoldOut || 'Ausverkauft';
    var GRAND_CRU_ICON = config.grandCruIcon || '';
    var CAFFEINE_FREE_LABEL = config.caffeineFreeLabel || '';

    var _search = null;
    var _searchInitialized = false;

    var filterSettings = { filters: [], showOutOfStock: true };
    try {
        if (typeof config.filterSettings === 'string') {
            filterSettings = JSON.parse(config.filterSettings);
        } else if (config.filterSettings && typeof config.filterSettings === 'object') {
            filterSettings = config.filterSettings;
        }
    } catch (e) {
        console.error('[ms-pg] Error parsing filterSettings:', e);
    }

    function escapeHtml(text) {
        if (text == null) return '';
        var d = document.createElement('div');
        d.textContent = String(text);
        return d.innerHTML;
    }

    var SRCSET_WIDTHS = [200, 360, 540, 720, 900, 1080];

    function shopifyImageUrl(src, width) {
        if (!src) return src;
        var sep = src.indexOf('?') !== -1 ? '&' : '?';
        return src + sep + 'width=' + width;
    }

    function shopifySrcset(src) {
        if (!src) return '';
        return SRCSET_WIDTHS
            .map(function (w) { return shopifyImageUrl(src, w) + ' ' + w + 'w'; })
            .join(', ');
    }

    function getMainImageUrl(hit) {
        var img = (hit && hit.images && hit.images.length) ? hit.images[0] : null;
        if (!img) return '';
        return typeof img === 'string' ? img : (img.src || img.url || '');
    }

    // Variant's own image, else the product's main image
    function getVariantImageUrl(hit, variantIndex) {
        if (!hit) return '';
        var variants = Array.isArray(hit.variants) ? hit.variants : [];
        var variant = variants[variantIndex];
        var vImg = variant && variant.image;
        if (vImg) {
            var u = typeof vImg === 'string' ? vImg : (vImg.src || vImg.url || '');
            if (u) return u;
        }
        return getMainImageUrl(hit);
    }

    function getImageUrl(hit) {
        return getMainImageUrl(hit);
    }

    function getLocalizedTitle(hit) {
        return hit['title_' + currentLocale] || hit.title || 'Produkt';
    }

    function getLocalizedHandle(hit) {
        return hit['handle_' + currentLocale] || hit.handle || '';
    }

    function getLocalizedCaption(hit) {
        return hit['metafield_aico_metafields_untertitel_' + currentLocale] || hit.metafield_aico_metafields_untertitel || '';
    }

    // Mirror Liquid's `handleize` so keys match the metaobject handles:
    // strip accent marks (NFD) and collapse any non-alphanumeric run to one hyphen.
    function handleizeTitle(title) {
        return String(title)
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/^-+|-+$/g, '');
    }

    // Match keys ignoring spaces/hyphens/case so "500g Beutel" == "500 g Beutel".
    function normalizeKey(title) {
        return handleizeTitle(title).replace(/-/g, '');
    }

    // Returns { image, label } for the variant swatch, or null. Tolerates a legacy string-only map.
    function getSwatchForVariant(variant) {
        if (!variant || !variant.title) return null;
        var hit = variantSwatches[normalizeKey(variant.title)];
        if (!hit) return null;
        return typeof hit === 'string' ? { image: hit, label: '' } : hit;
    }

    function isVariantAvailable(v) {
        // sellableOnlineQuantity reflects the online-sellable stock (availableForSale does not)
        return !!v && (Number(v.sellableOnlineQuantity) > 0 || v.inventoryPolicy === 'CONTINUE');
    }

    function findFirstAvailableIndex(variants) {
        if (!Array.isArray(variants)) return -1;
        for (var i = 0; i < variants.length; i++) {
            if (isVariantAvailable(variants[i])) return i;
        }
        return -1;
    }

    function getVariantDisplay(hit, variantIndex) {
        var variants = (hit && Array.isArray(hit.variants)) ? hit.variants : [];
        var idx = typeof variantIndex === 'number' ? variantIndex : 0;
        var variant = variants[idx] || variants[0] || null;
        var price = variant ? (parseFloat(variant.price) || 0) : 0;
        var compareAtPrice = variant ? (parseFloat(variant.compareAtPrice) || null) : null;
        var swatch = getSwatchForVariant(variant);
        return {
            variant: variant,
            index: idx,
            id: variant ? variant.id : '',
            title: variant ? (variant.title || '') : '',
            sku: variant ? (variant.sku || '') : '',
            available: isVariantAvailable(variant),
            price: price,
            compareAtPrice: compareAtPrice,
            onSale: compareAtPrice !== null && compareAtPrice > price,
            currency: (hit && hit.price && hit.price.currency) || 'CHF',
            imageUrl: getVariantImageUrl(hit, idx),
            swatchUrl: swatch ? swatch.image : '',
            swatchLabel: swatch ? swatch.label : ''
        };
    }

    function sanitizeId(val) {
        return String(val).replace(/[^a-zA-Z0-9]/g, '_');
    }

    function getFilterLabel(filter) {
        if (filter.translations && filter.translations[currentLocale]) {
            return filter.translations[currentLocale];
        }
        return filter.label || filter.meilisearchField;
    }

    function getEffectiveField(filter) {
        if (filter.translatable) {
            if (filter.meilisearchFields && filter.meilisearchFields[currentLocale]) {
                return filter.meilisearchFields[currentLocale];
            }
            if (currentLocale === 'fr' || currentLocale === 'en' || currentLocale === 'it') {
                return filter.meilisearchField + '_' + currentLocale;
            }
        }
        return filter.meilisearchField;
    }

    function getHitFavoriteHtml(hit, d, title, handle) {
        var priceStr = d.price.toFixed(2) + ' ' + d.currency;
        var compareStr = d.onSale ? d.compareAtPrice.toFixed(2) + ' ' + d.currency : '';
        var productId = hit.id == null ? '' : String(hit.id);
        return `
            <favorite-button
                class="fav-btn fav-btn--md fav-btn--aico-card"
                data-product-id="${escapeHtml(productId)}"
                data-product-handle="${escapeHtml(handle)}"
                data-product-title="${escapeHtml(title)}"
                data-variant-id="${escapeHtml(String(d.id))}"
                data-variant-title="${escapeHtml(d.title)}"
                data-price="${escapeHtml(priceStr)}"
                data-compare-at-price="${escapeHtml(compareStr)}"
                data-image="${escapeHtml(shopifyImageUrl(d.imageUrl, 400))}"
                data-sku="${escapeHtml(d.sku)}"
                data-available="${d.available ? 'true' : 'false'}">
                <button type="button" class="fav-btn__button" aria-pressed="false" aria-label="Zu Favoriten hinzufügen" title="Zu Favoriten hinzufügen">
                    <svg class="fav-btn__icon fav-btn__icon--outline" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <path d="M12 20.5s-7.2-4.15-9.6-8.9C1 7.9 3.7 3.8 7.5 3.8c2.1 0 3.55 1.15 4.5 2.55.95-1.4 2.4-2.55 4.5-2.55 3.8 0 6.5 4.1 5.1 7.8-2.4 4.75-9.6 8.9-9.6 8.9z" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linejoin="round"/>
                    </svg>
                    <svg class="fav-btn__icon fav-btn__icon--filled" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                        <path d="M12 20.5s-7.2-4.15-9.6-8.9C1 7.9 3.7 3.8 7.5 3.8c2.1 0 3.55 1.15 4.5 2.55.95-1.4 2.4-2.55 4.5-2.55 3.8 0 6.5 4.1 5.1 7.8-2.4 4.75-9.6 8.9-9.6 8.9z"/>
                    </svg>
                </button>
            </favorite-button>
        `;
    }

    // Product tags, lowercased + stripped of separators so "Best-Seller", "best_seller",
    // "Grand Cru", "grand-cru" etc. all normalize to "bestseller" / "grandcru".
    function getNormalizedTags(hit) {
        var raw = hit && hit.tags;
        if (typeof raw === 'string') raw = raw.split(',');
        if (!Array.isArray(raw)) return [];
        return raw.map(function (t) {
            return String(t).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
        });
    }

    function getHitStampHtml(hit, d, title, handle) {
        var tags = getNormalizedTags(hit);
        var stamp = '';
        // Grand Cru always wins over Bestseller when a product has both.
        if (tags.indexOf('grandcru') !== -1) {
            stamp = GRAND_CRU_ICON ? `<img class="ms-hit-stamp__img" src="${escapeHtml(GRAND_CRU_ICON)}" alt="Grand Cru" loading="lazy" />` : '';
        } else if (tags.indexOf('bestseller') !== -1) {
            stamp = 'BESTSELLER';
        }
        // Round "caffeine-free" badge (localized) for Theine Free products.
        var altStamp = (tags.indexOf('theinefree') !== -1 && CAFFEINE_FREE_LABEL) ? escapeHtml(CAFFEINE_FREE_LABEL) : '';
        return `
            <div class="ms-hit-top">
                <div class="ms-hit-stamp ms-hit--alt">${altStamp}</div>
                <span class="ms-hit-stamp">${stamp}</span>
                ${getHitFavoriteHtml(hit, d, title, handle)}
            </div>
        `;
    }

    function getHitVariantSwatch(variant, index, hit, activeIndex) {
        if (!variant || !variant.id) {
            return '';
        }

        var d = getVariantDisplay(hit, index);
        // Loose (offen) variants get a fixed swatch + label (window.AICO_OFFEN, see theme.liquid)
        var offen = window.AICO_OFFEN || {};
        var isOffen = String(d.title || '').toLowerCase().indexOf('offen') !== -1;
        var swatchUrl = isOffen ? offen.image || d.swatchUrl : d.swatchUrl;
        var label = isOffen ? (offen.label || d.title) : (d.swatchLabel || d.title);
        var isActive = index === activeIndex;
        var classes = ['ms-hit-swatch'];
        if (!swatchUrl) classes.push('ms-hit-swatch--empty');
        if (isActive) classes.push('ms-hit-swatch--active');
        if (!d.available) classes.push('ms-hit-swatch--unavailable');

        return `
            <button type="button"
                class="${classes.join(' ')}"
                data-variant-id="${d.id}"
                data-variant-index="${index}"
                data-image-url="${escapeHtml(d.imageUrl)}"
                data-price="${d.price}"
                data-compare-at-price="${d.compareAtPrice == null ? '' : d.compareAtPrice}"
                data-currency="${escapeHtml(d.currency)}"
                data-available="${d.available ? 'true' : 'false'}"
                title="${escapeHtml(label)}"${swatchUrl ? ` style="background-image:url('${escapeHtml(swatchUrl)}')"` : ''}>
                <span class="ms-hit-swatch-title">${escapeHtml(label)}</span>
            </button>
        `;
    }

    function getHitVariantsSliderHtml(hit) {
        if (!Array.isArray(hit.variants) || hit.variants.length === 0) {
            return '';
        }

        var variants = hit.variants;

        if (variants.length === 1) {
            var soldByWeight = hit.metafield_aico_sold_by_weight === true || hit.metafield_aico_sold_by_weight === 'true';
            var d0 = getVariantDisplay(hit, 0);
            if (!soldByWeight) {
                // Single-variant packaging (verpackung): match the metaobject on the base
                // (locale-independent) value for the icon, but display the localized value.
                var verpBase = hit.metafield_aico_metafields_verpackung;
                verpBase = verpBase == null ? '' : String(verpBase).trim();
                var verpLoc = hit['metafield_aico_metafields_verpackung_' + currentLocale];
                verpLoc = (verpLoc == null || verpLoc === '') ? '' : String(verpLoc).trim();
                var verpMatch = verpBase || verpLoc;
                if (!verpMatch) return '';
                var verpSw = variantSwatches[normalizeKey(verpMatch)];
                var verpImg = (verpSw && verpSw.image) ? verpSw.image : '';
                var verpLabel = verpLoc || verpBase;
                return `
                    <div class="ms-hit-variants-container">
                        <div class="ms-hit-variants-wrapper">
                            <button type="button" class="ms-hit-variants-btn ms-hit-variants-previous-btn" hidden></button>
                            <div class="ms-hit-variants-viewport">
                                <div class="ms-hit-variants-track${verpImg ? '' : ' ms-hit-variants-track--text'}" data-index="0">
                                    <button type="button"
                                        class="ms-hit-swatch ms-hit-swatch--active${verpImg ? '' : ' ms-hit-swatch--empty'}"
                                        data-variant-id="${escapeHtml(String(variants[0].id))}"
                                        data-variant-index="0"
                                        data-image-url="${escapeHtml(d0.imageUrl)}"
                                        data-price="${d0.price}"
                                        data-compare-at-price="${d0.compareAtPrice == null ? '' : d0.compareAtPrice}"
                                        data-currency="${escapeHtml(d0.currency)}"
                                        data-available="${d0.available ? 'true' : 'false'}"
                                        ${verpImg ? `style="background-image:url('${escapeHtml(verpImg)}')"` : ''}
                                        title="${escapeHtml(verpLabel)}">
                                        <span class="ms-hit-swatch-title">${escapeHtml(verpLabel)}</span>
                                    </button>
                                </div>
                            </div>
                            <button type="button" class="ms-hit-variants-btn ms-hit-variants-next-btn" hidden></button>
                        </div>
                    </div>
                `;
            }
            var offen = window.AICO_OFFEN || {};
            return `
                <div class="ms-hit-variants-container">
                    <div class="ms-hit-variants-wrapper">
                        <button type="button" class="ms-hit-variants-btn ms-hit-variants-previous-btn" hidden></button>
                        <div class="ms-hit-variants-viewport">
                            <div class="ms-hit-variants-track" data-index="0">
                                <button type="button"
                                    class="ms-hit-swatch ms-hit-swatch--active"
                                    data-variant-id="${escapeHtml(String(variants[0].id))}"
                                    data-variant-index="0"
                                    data-image-url="${escapeHtml(d0.imageUrl)}"
                                    data-price="${d0.price}"
                                    data-compare-at-price="${d0.compareAtPrice == null ? '' : d0.compareAtPrice}"
                                    data-currency="${escapeHtml(d0.currency)}"
                                    data-available="${d0.available ? 'true' : 'false'}"
                                    style="background-image:url('${escapeHtml(offen.image || '')}')"
                                    title="${escapeHtml(offen.label || '')}">
                                    <span class="ms-hit-swatch-title">${escapeHtml(offen.label || '')}</span>
                                </button>
                            </div>
                        </div>
                        <button type="button" class="ms-hit-variants-btn ms-hit-variants-next-btn" hidden></button>
                    </div>
                </div>
            `;
        }

        var visible = getVisibleSwatchCount();
        var hasOverflow = variants.length > visible;
        var firstAvail = findFirstAvailableIndex(variants);
        var activeIndex = firstAvail >= 0 ? firstAvail : 0;
        var maxIndex = Math.max(0, variants.length - visible);
        var initialTrackIndex = Math.min(activeIndex, maxIndex);

        // If no variant has a swatch image, render compact, centered text-only chips.
        var offen = window.AICO_OFFEN || {};
        var hasSwatchImage = variants.some(function (v, i) {
            var d = getVariantDisplay(hit, i);
            var isOffen = String(d.title || '').toLowerCase().indexOf('offen') !== -1;
            return !!(isOffen ? (offen.image || d.swatchUrl) : d.swatchUrl);
        });
        var trackTextClass = hasSwatchImage ? '' : ' ms-hit-variants-track--text';

        return `
            <div class="ms-hit-variants-container">
                <div class="ms-hit-variants-wrapper">
                    <button type="button" class="ms-hit-variants-btn ms-hit-variants-previous-btn"${initialTrackIndex === 0 ? ' hidden' : ''}></button>
                    <div class="ms-hit-variants-viewport">
                        <div class="ms-hit-variants-track${trackTextClass}" data-index="${initialTrackIndex}">
                            ${variants.map((v, i) => getHitVariantSwatch(v, i, hit, activeIndex)).join('')}
                        </div>
                    </div>
                    <button type="button" class="ms-hit-variants-btn ms-hit-variants-next-btn"${(hasOverflow && initialTrackIndex < maxIndex) ? '' : ' hidden'}></button>
                </div>
            </div>
        `;
    }

    function getVisibleSwatchCount() {
        return window.matchMedia('(max-width: 768px)').matches ? 2 : 3;
    }

    function applyInitialSwatchScroll() {
        document.querySelectorAll('.ms-hit-variants-track').forEach(function (track) {
            var idx = parseInt(track.dataset.index || '0', 10);
            if (idx <= 0) return;
            var swatches = track.querySelectorAll('.ms-hit-swatch');
            if (!swatches.length) return;
            var swatchWidth = swatches[0].getBoundingClientRect().width;
            if (swatchWidth <= 0) return;
            var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
            track.style.transform = 'translateX(' + (-idx * (swatchWidth + gap)) + 'px)';
        });
    }

    function shiftVariantsSlider(wrapper, direction) {
        var track = wrapper.querySelector('.ms-hit-variants-track');
        if (!track) return;
        var swatches = track.querySelectorAll('.ms-hit-swatch');
        var total = swatches.length;
        var visible = getVisibleSwatchCount();
        if (total <= visible) return;

        var currentIndex = parseInt(track.dataset.index || '0', 10);
        var maxIndex = total - visible;
        var newIndex = direction === 'prev' ? currentIndex - 1 : currentIndex + 1;
        newIndex = Math.max(0, Math.min(maxIndex, newIndex));
        if (newIndex === currentIndex) return;

        track.dataset.index = newIndex;
        var swatchWidth = swatches[0].getBoundingClientRect().width;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        track.style.transform = 'translateX(' + (-newIndex * (swatchWidth + gap)) + 'px)';

        var prevBtn = wrapper.querySelector('.ms-hit-variants-previous-btn');
        var nextBtn = wrapper.querySelector('.ms-hit-variants-next-btn');
        if (prevBtn) prevBtn.hidden = newIndex === 0;
        if (nextBtn) nextBtn.hidden = newIndex === maxIndex;
    }

    function getHitPriceHtml(hit, activeIndex) {
        var d = getVariantDisplay(hit, activeIndex);

        return `
            <div class="ms-pg-hit-price">
                <span class="ms-pg-hit-normal-price ${d.onSale ? 'ms-pg-hit-sale-price' : ''}">${d.price.toFixed(2)} ${escapeHtml(d.currency)}</span>
                ${d.onSale ? `<span class="ms-pg-compare-at-price">${d.compareAtPrice.toFixed(2)} ${escapeHtml(d.currency)}</span>` : ''}
            </div>
        `;
    }

    function renderHitHtml(hit) {
        var title = getLocalizedTitle(hit);
        var handle = getLocalizedHandle(hit);
        var caption = getLocalizedCaption(hit);
        var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var url = rootPath + 'products/' + handle;

        var variants = Array.isArray(hit.variants) ? hit.variants : [];
        var firstAvail = findFirstAvailableIndex(variants);
        var activeIndex = firstAvail >= 0 ? firstAvail : 0;
        var d = getVariantDisplay(hit, activeIndex);
        var btnAvailable = firstAvail >= 0;
        var btnText = btnAvailable ? T_CART_ADD : T_SOLD_OUT;
        var imgSrc = d.imageUrl;

        return `
            <li class="ms-hit">
               <div class="ms-hit-container">
                    ${getHitStampHtml(hit, d, title, handle)}
                    <div class="ms-hit-wrapper">
                        <a href="${escapeHtml(url)}" class="ms-hit-link">
                            <span class="ms-hit-image-container">
                                <span class="ms-hit-image-wrapper">
                                    <img src="${escapeHtml(shopifyImageUrl(imgSrc, 540))}" srcset="${escapeHtml(shopifySrcset(imgSrc))}" sizes="(max-width: 768px) 50vw, (max-width: 1200px) 33vw, 25vw" alt="${escapeHtml(title)}" class="ms-pg-hit-image" loading="lazy" width="216" height="216" />
                                </span>
                            </span>
                        </a>

                        <div class="ms-hit-details">
                            <a class="ms-pg-hit-title" href="${escapeHtml(url)}">${escapeHtml(title)}</a>
                            <div class="ms-hit-caption">${escapeHtml(caption)}</div>
                        </div>

                        <div class="ms-hit-inner">
                            ${getHitVariantsSliderHtml(hit)}
                            <div class="ms-hit-bottom">
                                ${getHitPriceHtml(hit, activeIndex)}
                                <div class="ms-hit-add-to-cart-wrapper">
                                    <button type="button" class="ms-hit-add-to-cart" data-variant-id="${d.id}"${btnAvailable ? '' : ' disabled'}>${btnText}</button>
                                </div>
                            </div>
                        </div>
                    </div>
               </div>
            </li>
        `;
    }

    function checkAndInit() {
        if (_searchInitialized) return true;
        if (typeof window.instantsearch !== 'undefined' && typeof instantMeiliSearch !== 'undefined') {
            _searchInitialized = true;
            startSearch();
            return true;
        }
        return false;
    }

    function initSearch() {
        if (checkAndInit()) return;
        var attempts = 0;
        var timer = setInterval(function () {
            attempts++;
            if (checkAndInit() || attempts > 50) {
                clearInterval(timer);
                if (attempts > 50) {
                    console.error('[ms-pg] InstantSearch libraries failed to load.');
                }
            }
        }, 100);
    }

    function startSearch() {
        var searchClient = instantMeiliSearch(MEILISEARCH_HOST, MEILISEARCH_API_KEY, {
            primaryKey: 'id',
            finitePagination: true,
            keepZeroFacets: false
        });

        var baseFilters = [];
        if (collectionId) baseFilters.push('collections.id = ' + collectionId);
        if (!showOutOfStock) baseFilters.push('(variants.sellableOnlineQuantity > 0 OR variants.inventoryPolicy = "CONTINUE")');
        var baseFilterString = baseFilters.join(' AND ');

        var DEFAULT_SORT = MEILISEARCH_INDEX;

        var sortedFilters = (filterSettings.filters || [])
            .filter(function (f) {
                if (!f.excludedOnCollections || !f.excludedOnCollections.length) return true;
                return f.excludedOnCollections.indexOf(collectionHandle) === -1;
            })
            .sort(function (a, b) { return a.position - b.position; });

        var fieldLabelMap = {};
        sortedFilters.forEach(function (f) {
            var label = getFilterLabel(f);
            fieldLabelMap[f.meilisearchField] = label;
            var effField = getEffectiveField(f);
            if (effField !== f.meilisearchField) {
                fieldLabelMap[effField] = label;
            }
        });

        _search = window.instantsearch({
            indexName: DEFAULT_SORT,
            searchClient: searchClient.searchClient,
            insights: false,
            routing: {
                stateMapping: {
                    stateToRoute: function (uiState) {
                        var idx = uiState[Object.keys(uiState)[0]] || {};
                        var route = {};
                        if (idx.refinementList) {
                            Object.keys(idx.refinementList).forEach(function (attr) {
                                var vals = idx.refinementList[attr];
                                if (vals && vals.length) {
                                    var key = attr.indexOf('filter_') === 0 ? attr.slice(7) : attr;
                                    route[key] = vals.join(',');
                                }
                            });
                        }
                        if (idx.sortBy && idx.sortBy !== DEFAULT_SORT) {
                            route.sort = idx.sortBy.replace(MEILISEARCH_INDEX + ':', '');
                        }
                        if (idx.page && idx.page > 1) {
                            route.page = idx.page;
                        }
                        if (searchMode && idx.query) route.q = idx.query;
                        return route;
                    },
                    routeToState: function (route) {
                        var reserved = { sort: true, q: true, page: true };
                        var filterKeys = {};
                        sortedFilters.forEach(function (f) {
                            var effField = getEffectiveField(f);
                            var short = f.meilisearchField.indexOf('filter_') === 0
                                ? f.meilisearchField.slice(7)
                                : f.meilisearchField;
                            filterKeys[short] = effField;
                            if (effField !== f.meilisearchField) {
                                var effShort = effField.indexOf('filter_') === 0 ? effField.slice(7) : effField;
                                filterKeys[effShort] = effField;
                            }
                        });
                        var refinementList = {};
                        Object.keys(route).forEach(function (key) {
                            if (reserved[key]) return;
                            var attr = filterKeys[key] || key;
                            if (route[key]) refinementList[attr] = route[key].split(',');
                        });
                        var state = {};
                        if (Object.keys(refinementList).length) state.refinementList = refinementList;
                        if (route.sort) state.sortBy = MEILISEARCH_INDEX + ':' + route.sort;
                        if (route.page) {
                            var p = parseInt(route.page, 10);
                            if (!isNaN(p) && p > 1) state.page = p;
                        }
                        if (searchMode) state.query = route.q || initialQuery;
                        var uiState = {};
                        uiState[DEFAULT_SORT] = state;
                        return uiState;
                    }
                }
            }
        });

        var configureOptions = { hitsPerPage: productsPerPage };
        if (baseFilterString) configureOptions.filters = baseFilterString;
        _search.addWidgets([window.instantsearch.widgets.configure(configureOptions)]);

        // --- Filters (refinement lists) ---
        sortedFilters.forEach(function (filter) {
            var baseField = filter.meilisearchField;
            var effectiveField = getEffectiveField(filter);
            var facetEl = document.getElementById('ms-facet-' + baseField);
            var ul = document.getElementById('ms-facet-options-' + baseField);
            if (!facetEl || !ul) return;

            var currentRefine = null;

            ul.addEventListener('change', function (e) {
                if (e.target.type === 'checkbox' && currentRefine) {
                    currentRefine(e.target.dataset.value);
                }
            });

            var customRefinement = window.instantsearch.connectors.connectRefinementList(
                function (renderState, isFirstRender) {
                    currentRefine = renderState.refine;
                    if (isFirstRender) return;
                    facetEl.style.display = renderState.items.length === 0 ? 'none' : '';
                    if (renderState.items.length === 0) return;

                    ul.innerHTML = renderState.items.map(function (item) {
                        var inputId = 'ms-facet-' + sanitizeId(baseField) + '-' + sanitizeId(item.value);
                        return (
                            '<li class="ms-facet-option-row">' +
                            '<input type="checkbox"' +
                            ' id="' + inputId + '"' +
                            ' class="ms-facet-option"' +
                            ' data-value="' + escapeHtml(item.value) + '"' +
                            (item.isRefined ? ' checked' : '') + '>' +
                            '<label for="' + inputId + '" class="ms-facet-option-label' +
                            (item.isRefined ? ' ms-facet-option-label--active' : '') + '">' +
                            '<span class="ms-facet-option-value">' + escapeHtml(item.label) + ' </span>' +
                            '<span class="ms-facet-option-count">(' + item.count + ')</span>' +
                            '</label>' +
                            '</li>'
                        );
                    }).join('');
                }
            );

            _search.addWidgets([customRefinement({
                attribute: effectiveField,
                operator: 'or',
                limit: 100,
                sortBy: ['name:asc']
            })]);
        });

        // --- Active refinements (chips) ---
        var _currentRefinementsState = null;
        var renderCurrentRefinements = window.instantsearch.connectors.connectCurrentRefinements(
            function (renderState) {
                _currentRefinementsState = renderState;
                var wrapper = document.querySelector('.ms-active-facets');
                var listEl = document.querySelector('.ms-active-facets-list');
                var clearEl = document.querySelector('.ms-clear-active');
                if (!wrapper || !listEl) return;

                var items = renderState.items || [];
                var hasRefinements = items.some(function (i) { return i.refinements.length > 0; });

                if (!hasRefinements) {
                    listEl.innerHTML = '';
                    wrapper.hidden = true;
                    if (clearEl) clearEl.style.display = 'none';
                    return;
                }

                wrapper.hidden = false;
                if (clearEl) clearEl.style.display = '';

                var html = items.map(function (item) {
                    var label = fieldLabelMap[item.attribute] || item.attribute;
                    return item.refinements.map(function (r) {
                        return '<li class="ms-active-facet" data-attr="' + escapeHtml(item.attribute) + '" data-val="' + escapeHtml(String(r.value)) + '">' +
                            '<span>' + escapeHtml(label) + ': ' + escapeHtml(r.label) + '</span>' +
                            '<button type="button" class="ms-active-facet-remove" aria-label="Remove"><span class="visually-hidden">Remove</span></button>' +
                            '</li>';
                    }).join('');
                }).join('');

                listEl.innerHTML = html;
            }
        );
        _search.addWidgets([renderCurrentRefinements({})]);

        // --- Sort options ---
        var sortEls = document.querySelectorAll('.ms-sort-option');
        var sortItems = [];
        sortEls.forEach(function (el) {
            var v = el.dataset.value;
            if (!v) return;
            sortItems.push({ label: el.textContent.trim(), value: MEILISEARCH_INDEX + ':' + v });
        });
        sortItems.unshift({ label: '__default__', value: DEFAULT_SORT });

        var renderSortBy = window.instantsearch.connectors.connectSortBy(
            function (renderState, isFirstRender) {
                sortEls.forEach(function (el) {
                    var v = el.dataset.value;
                    var val = v ? MEILISEARCH_INDEX + ':' + v : DEFAULT_SORT;
                    el.setAttribute('aria-selected', val === renderState.currentRefinement ? 'true' : 'false');
                });

                if (isFirstRender) {
                    sortEls.forEach(function (el) {
                        el.addEventListener('click', function () {
                            var v = el.dataset.value;
                            var val = v ? MEILISEARCH_INDEX + ':' + v : DEFAULT_SORT;
                            renderState.refine(val);
                        });
                    });
                }
            }
        );
        _search.addWidgets([renderSortBy({ items: sortItems })]);

        // --- Hits ---
        var _searchInFlight = false;
        var _scrollToTopPending = false;
        _search.on('search', function () { _searchInFlight = true; });
        _search.on('render', function () {
            _searchInFlight = false;
            if (_scrollToTopPending) {
                _scrollToTopPending = false;
                requestAnimationFrame(function () {
                    requestAnimationFrame(function () {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    });
                });
            }
        });
        _search.on('error', function () { _searchInFlight = false; _scrollToTopPending = false; });

        var renderHits = window.instantsearch.connectors.connectHits(
            function (renderState, isFirstRender) {
                var container = document.getElementById('ms-hits');
                if (!container) return;
                var hits = renderState.hits;
                var results = renderState.results;

                if (hits.length > 0) {
                    container.innerHTML = hits.map(renderHitHtml).join('');
                    requestAnimationFrame(applyInitialSwatchScroll);
                    return;
                }

                if (_searchInFlight) return;

                if (results && results.nbHits === 0) {
                    container.innerHTML = '<li class="ms-pg-no-results">' +
                        (config.noProductsMessage || 'Keine Produkte gefunden.') + '</li>';
                }
            }
        );
        _search.addWidgets([renderHits({})]);

        // --- Total products count (desktop + mobile) ---
        var _totalSuffix = config.totalProductsSuffix || '';
        var renderStats = window.instantsearch.connectors.connectStats(
            function (renderState, isFirstRender) {
                if (isFirstRender) return;
                var nb = renderState.nbHits || 0;
                var text = nb + (_totalSuffix ? ' ' + _totalSuffix : '');
                document.querySelectorAll('#ms-total-products, #ms-total-products-mobile')
                    .forEach(function (el) { el.textContent = text; });
            }
        );
        _search.addWidgets([renderStats({})]);

        // --- Pagination ---
        var _paginationRefine = null;
        var renderPagination = window.instantsearch.connectors.connectPagination(
            function (renderState) {
                var container = document.querySelector('.ms-pages');
                if (!container) return;

                _paginationRefine = renderState.refine;

                var pages = renderState.pages;
                var current = renderState.currentRefinement;
                var nbPages = renderState.nbPages;
                var createURL = renderState.createURL;
                var isFirst = renderState.isFirstPage;
                var isLast = renderState.isLastPage;

                if (nbPages <= 1) {
                    container.innerHTML = '';
                    return;
                }

                var html = '';
                html += '<li class="ms-page ms-page--prev' + (isFirst ? ' ms-page--disabled' : '') + '">' +
                    '<a href="' + createURL(current - 1) + '" data-page="' + (current - 1) + '" aria-label="Previous"><span class="visually-hidden">Previous</span></a>' +
                    '</li>';

                pages.forEach(function (page) {
                    html += '<li class="ms-page' + (page === current ? ' ms-page--active' : '') + '">' +
                        '<a href="' + createURL(page) + '" data-page="' + page + '">' + (page + 1) + '</a>' +
                        '</li>';
                });

                html += '<li class="ms-page ms-page--next' + (isLast ? ' ms-page--disabled' : '') + '">' +
                    '<a href="' + createURL(current + 1) + '" data-page="' + (current + 1) + '" aria-label="Next"></a>' +
                    '</li>';

                container.innerHTML = html;
            }
        );
        _search.addWidgets([renderPagination({ padding: 2 })]);

        document.addEventListener('click', function (e) {
            var link = e.target.closest('.ms-pages a[data-page]');
            if (!link) return;
            e.preventDefault();
            if (!_paginationRefine) return;
            var page = parseInt(link.dataset.page, 10);
            if (isNaN(page) || page < 0) return;
            _scrollToTopPending = true;
            _paginationRefine(page);
        });

        document.addEventListener('click', function (e) {
            var removeBtn = e.target.closest('.ms-active-facet-remove');
            if (removeBtn) {
                var item = removeBtn.closest('.ms-active-facet');
                if (!item || !_currentRefinementsState) return;
                var attr = item.dataset.attr;
                var val = item.dataset.val;
                _currentRefinementsState.items.forEach(function (i) {
                    if (i.attribute === attr) {
                        i.refinements.forEach(function (r) {
                            if (String(r.value) === val) {
                                _currentRefinementsState.refine(r);
                            }
                        });
                    }
                });
                return;
            }

            var clearAll = e.target.closest('.ms-clear-active');
            if (clearAll && _currentRefinementsState) {
                _currentRefinementsState.items.forEach(function (i) {
                    i.refinements.forEach(function (r) {
                        _currentRefinementsState.refine(r);
                    });
                });
            }
        });

        if (searchMode) {
            var virtualSearchBox = window.instantsearch.connectors.connectSearchBox(function () { });
            _search.addWidgets([virtualSearchBox({})]);
        }

        _search.start();
    }

    var _preloadedCards = new WeakSet();
    function preloadCardVariantImages(card) {
        if (!card || _preloadedCards.has(card)) return;
        _preloadedCards.add(card);
        var seen = {};
        card.querySelectorAll('.ms-hit-swatch').forEach(function (sw) {
            var url = sw.dataset.imageUrl;
            if (!url || seen[url]) return;
            seen[url] = true;
            var img = new Image();
            img.src = shopifyImageUrl(url, 540);
        });
    }
    document.addEventListener('mouseenter', function (e) {
        var card = e.target.closest && e.target.closest('.ms-hit');
        if (card) preloadCardVariantImages(card);
    }, true);
    document.addEventListener('touchstart', function (e) {
        var card = e.target.closest && e.target.closest('.ms-hit');
        if (card) preloadCardVariantImages(card);
    }, { passive: true, capture: true });

    document.addEventListener('click', function (e) {
        var btn = e.target.closest('.ms-hit-variants-btn');
        if (!btn) return;
        var wrapper = btn.closest('.ms-hit-variants-wrapper');
        if (!wrapper) return;
        var direction = btn.classList.contains('ms-hit-variants-previous-btn') ? 'prev' : 'next';
        shiftVariantsSlider(wrapper, direction);
    });

    // Swipe the variant swatch slider (touch + mouse/pen drag). Delegated on
    // document because hits are re-rendered dynamically. A real horizontal
    // swipe steps the slider; its trailing swatch-select click is suppressed.
    (function () {
        var SWIPE_THRESHOLD = 25; // px needed to trigger a swatch step
        var activeWrapper = null;
        var startX = 0, startY = 0, deltaX = 0, dragging = false, isHorizontal = false, swiped = false;

        function onStart(target, x, y) {
            var viewport = target.closest && target.closest('.ms-hit-variants-viewport');
            activeWrapper = viewport ? viewport.closest('.ms-hit-variants-wrapper') : null;
            if (!activeWrapper) { dragging = false; return; }
            startX = x; startY = y; deltaX = 0;
            dragging = true; isHorizontal = false; swiped = false;
        }
        function onMove(x, y, e) {
            if (!dragging) return;
            deltaX = x - startX;
            var deltaY = y - startY;
            if (!isHorizontal && Math.abs(deltaX) < 10 && Math.abs(deltaY) < 10) return;
            if (!isHorizontal) isHorizontal = Math.abs(deltaX) > Math.abs(deltaY);
            if (isHorizontal && e && e.cancelable) e.preventDefault();
        }
        function onEnd() {
            if (!dragging) return;
            dragging = false;
            if (!isHorizontal || !activeWrapper) return;
            if (deltaX <= -SWIPE_THRESHOLD) { swiped = true; shiftVariantsSlider(activeWrapper, 'next'); }
            else if (deltaX >= SWIPE_THRESHOLD) { swiped = true; shiftVariantsSlider(activeWrapper, 'prev'); }
        }

        // Touch
        document.addEventListener('touchstart', function (e) {
            if (e.touches.length !== 1) return;
            onStart(e.target, e.touches[0].clientX, e.touches[0].clientY);
        }, { passive: true });
        document.addEventListener('touchmove', function (e) {
            if (!dragging) return;
            onMove(e.touches[0].clientX, e.touches[0].clientY, e);
        }, { passive: false });
        document.addEventListener('touchend', onEnd);
        document.addEventListener('touchcancel', onEnd);

        // Pointer (mouse / pen); touch handled above
        if (window.PointerEvent) {
            document.addEventListener('pointerdown', function (e) {
                if (e.pointerType === 'touch') return;
                onStart(e.target, e.clientX, e.clientY);
            });
            document.addEventListener('pointermove', function (e) {
                if (e.pointerType === 'touch' || !dragging) return;
                onMove(e.clientX, e.clientY, e);
            });
            document.addEventListener('pointerup', function (e) {
                if (e.pointerType === 'touch') return;
                onEnd();
            });
            document.addEventListener('pointercancel', function (e) {
                if (e.pointerType === 'touch') return;
                onEnd();
            });
        }

        // Cancel the swatch-select click that fires at the end of a drag.
        document.addEventListener('click', function (e) {
            if (swiped && e.target.closest && e.target.closest('.ms-hit-variants-viewport')) {
                e.preventDefault();
                e.stopPropagation();
                swiped = false;
            }
        }, true);
    })();

    document.addEventListener('click', function (e) {
        var swatch = e.target.closest('.ms-hit-swatch');
        if (!swatch) return;
        var card = swatch.closest('.ms-hit');
        if (!card) return;

        card.querySelectorAll('.ms-hit-swatch').forEach(function (s) {
            s.classList.remove('ms-hit-swatch--active');
        });
        swatch.classList.add('ms-hit-swatch--active');

        var imgUrl = swatch.dataset.imageUrl;
        var img = card.querySelector('.ms-pg-hit-image');
        if (img && imgUrl) {
            img.src = shopifyImageUrl(imgUrl, 540);
            img.srcset = shopifySrcset(imgUrl);
        }

        var price = parseFloat(swatch.dataset.price) || 0;
        var compareAt = parseFloat(swatch.dataset.compareAtPrice) || 0;
        var currency = swatch.dataset.currency || 'CHF';
        var onSale = compareAt > 0 && compareAt > price;

        var priceContainer = card.querySelector('.ms-pg-hit-price');
        if (priceContainer) {
            priceContainer.innerHTML = `
                <span class="ms-pg-hit-normal-price ${onSale ? 'ms-pg-hit-sale-price' : ''}">${price.toFixed(2)} ${escapeHtml(currency)}</span>
                ${onSale ? `<span class="ms-pg-compare-at-price">${compareAt.toFixed(2)} ${escapeHtml(currency)}</span>` : ''}
            `;
        }

        var btn = card.querySelector('.ms-hit-add-to-cart');
        if (btn) {
            var available = swatch.dataset.available === 'true';
            btn.disabled = !available;
            btn.textContent = available ? T_CART_ADD : T_SOLD_OUT;
            btn.dataset.variantId = swatch.dataset.variantId;
        }

        // Wishlist heart follows the selected variant
        var fav = card.querySelector('favorite-button');
        if (fav) {
            fav.dataset.variantId = swatch.dataset.variantId;
            fav.dataset.price = price.toFixed(2) + ' ' + currency;
            fav.dataset.compareAtPrice = onSale ? compareAt.toFixed(2) + ' ' + currency : '';
            if (imgUrl) fav.dataset.image = shopifyImageUrl(imgUrl, 400);
            fav.dataset.available = swatch.dataset.available;
            var favVt = swatch.querySelector('.ms-hit-swatch-title');
            if (favVt) fav.dataset.variantTitle = favVt.textContent.trim();
            if (typeof fav.update === 'function') fav.update();
        }
    });

    document.addEventListener('click', async function (e) {
        var btn = e.target.closest('.ms-hit-add-to-cart');
        if (!btn || btn.disabled) return;
        e.preventDefault();

        var card = btn.closest('.ms-hit');
        var activeSwatch = card && card.querySelector('.ms-hit-swatch--active');
        var variantId = (activeSwatch && activeSwatch.dataset.variantId) || btn.dataset.variantId;
        if (!variantId) return;

        var original = btn.textContent;
        btn.disabled = true;
        btn.textContent = T_CART_ADDING;

        try {
            var res = await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
            });

            if (!res.ok) {
                var errBody = null;
                try { errBody = await res.json(); } catch (_) { }
                console.error('[ms-pg] add to cart rejected:', res.status, errBody);
                btn.textContent = res.status === 422 ? T_CART_LIMIT : (errBody && (errBody.description || errBody.message)) || ('Fehler ' + res.status);
                setTimeout(function () {
                    btn.textContent = original;
                    btn.disabled = false;
                }, 2000);
                return;
            }

            document.dispatchEvent(new CustomEvent('cart:update', {
                detail: { data: { itemCount: 1, source: 'product-form-component' } }
            }));

            btn.textContent = T_CART_ADDED;
            setTimeout(function () {
                btn.textContent = original;
                btn.disabled = false;
            }, 1500);
        } catch (err) {
            console.error('[ms-pg] add to cart failed:', err);
            btn.textContent = original;
            btn.disabled = false;
        }
    });

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initSearch);
    } else {
        initSearch();
    }
})();
